import styled from 'styled-components';

export const ImageWrapper = styled.div`
  text-align: center;
`;

export const DownvoteHeaderText = styled.div`
  font-family: 'Vodafone';
  text-align: center;
  font-size: 40px;
  margin-top: 20px;

  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

export const DownvoteFeedback = styled.div`
  font-family: 'Vodafone';
  font-weight: 200;
  padding: 1em;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  text-align: center;

  @media (max-width: 640px) {
    button {
      width: auto !important;
    }
  }
`;

export const CardButtonContainer = styled.div`
  text-align: center;
  padding-bottom: 20px;

  @media (max-width: 640px) {
    button {
      width: 90% !important;
    }
  }
`;

export const ContentContainer = styled.div`
  background-color: #f4f4f4;
  padding-bottom: 30px;
  margin-left: -40px;
  margin-right: -40px;
  margin-top: -40px;
  @media (max-width: 1024px) {
    margin-left: -32px;
    margin-right: -32px;
    margin-top: -32px;
  }
`;

export const CardsContainer = styled.div`
  background-color: #ffffff;
`;
